import http from "../http-rda";

class PititimPricesService {
  getAll(params) {
    return http.get("/pititim-prices", { params });
  }

  create(data) {
    return http.post("/pititim-prices", data);
  }

  update(id, data) {
    return http.patch(`/pititim-prices/${id}`, data);
  }

  delete(id) {
    return http.delete(`/pititim-prices/${id}`);
  }
}

export default new PititimPricesService();
